module.exports = __webpack_public_path__ + "static/img/agree-bg.aeb084a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/agree-bg.png
// module id = cLhl
// module chunks = 1